var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 2L64 18V50L34 66L4 50V18L34 2Z",
    fill: "#E1F5FE",
    stroke: "#0277BD",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6666 44.5V42.1667C38.6666 40.929 38.1749 39.742 37.2997 38.8668C36.4246 37.9917 35.2376 37.5 33.9999 37.5H26.9999C25.7622 37.5 24.5753 37.9917 23.7001 38.8668C22.8249 39.742 22.3333 40.929 22.3333 42.1667V44.5",
    stroke: "#0277BD",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4999 32.8333C33.0772 32.8333 35.1666 30.744 35.1666 28.1667C35.1666 25.5893 33.0772 23.5 30.4999 23.5C27.9226 23.5 25.8333 25.5893 25.8333 28.1667C25.8333 30.744 27.9226 32.8333 30.4999 32.8333Z",
    stroke: "#0277BD",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6667 44.5V42.1667C45.666 41.1327 45.3218 40.1282 44.6883 39.311C44.0549 38.4938 43.1679 37.9102 42.1667 37.6517",
    stroke: "#0277BD",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6667 23.6517C39.6706 23.9087 40.5603 24.4925 41.1957 25.311C41.831 26.1296 42.1759 27.1363 42.1759 28.1725C42.1759 29.2087 41.831 30.2154 41.1957 31.034C40.5603 31.8525 39.6706 32.4363 38.6667 32.6933",
    stroke: "#0277BD",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon);
export default __webpack_public_path__ + "static/media/SocialIcon.3773391b3c2c12669d301f8b59522a45.svg";
export { ForwardRef as ReactComponent };